// Ссылка на регистрацию кейс-чемпионата.
export const REGISTRATION_URL =
  "https://lk.case-in.ru/registration/2026/Telecom-Case-T2";
